module.exports = __webpack_public_path__ + "static/media/gamesPlayed_1000000.96336016.png";